import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { hasElements } from "Utils/Array";
import { selectSelectedOrActiveProjects } from "Store/Selectors/Projects";
import { projectsRelevanceStart } from "Store/Actions";
import { useAuthenticationPreflight } from "Components/Generic/Authentication";
import { IAction } from "./IAction";

export function useRelevance(): [boolean, IAction] {
  const dispatch = useDispatch();
  const { preflightAuthentication } = useAuthenticationPreflight();
  const selectedProjects = useSelector(selectSelectedOrActiveProjects);
  const allowRelevance = hasElements(selectedProjects) && selectedProjects.length <= 10;

  const onRelevance = useCallback(async () => {
    if (!allowRelevance) {
      return;
    }

    await preflightAuthentication();
    dispatch(projectsRelevanceStart());
  }, [allowRelevance, dispatch, preflightAuthentication]);

  return [allowRelevance, onRelevance];
}
